import Constants from './services/constants/Constants'

export default function resetStore (initialStateStore) {
  if (initialStateStore.libraryWS !== undefined && initialStateStore.libraryWS.medias !== undefined &&
    initialStateStore.libraryWS.medias.length > 0) initialStateStore.libraryWS.medias = []
  if (initialStateStore.libraryWS !== undefined && initialStateStore.libraryWS.icons !== undefined &&
    initialStateStore.libraryWS.icons.length > 0) initialStateStore.libraryWS.icons = []
  if (initialStateStore.libraryWS !== undefined && initialStateStore.libraryWS.iconsTags !== undefined &&
    initialStateStore.libraryWS.iconsTags.length > 0) initialStateStore.libraryWS.iconsTags = []
  if (initialStateStore.libraryWS !== undefined && initialStateStore.libraryWS.imagesTags !== undefined &&
    initialStateStore.libraryWS.imagesTags.length > 0) initialStateStore.libraryWS.imagesTags = []
  if (initialStateStore.libraryWS !== undefined && initialStateStore.libraryWS.images !== undefined &&
    initialStateStore.libraryWS.images.length > 0) initialStateStore.libraryWS.images = []

  if (initialStateStore.appWS !== undefined &&
    initialStateStore.appWS.apps.length > 0) initialStateStore.appWS.apps = []

  if (initialStateStore.userManagementWS !== undefined &&
    initialStateStore.userManagementWS.users.length > 0) initialStateStore.userManagementWS.users = []

  if (initialStateStore.beaconWS !== undefined &&
    initialStateStore.beaconWS.beacons.length > 0) initialStateStore.beaconWS.beacons = []

  if (initialStateStore.apiKeyWS !== undefined &&
    initialStateStore.apiKeyWS.apiKeys.length > 0) initialStateStore.apiKeyWS.apiKeys = []

  if (initialStateStore.http !== undefined &&
    initialStateStore.http.httpStatus) initialStateStore.http.httpStatus = ''
  if (initialStateStore.http !== undefined &&
    initialStateStore.http.text) initialStateStore.http.text = ''
  if (initialStateStore.http !== undefined &&
    initialStateStore.http.error) initialStateStore.http.error = undefined
  if (initialStateStore.http !== undefined &&
    initialStateStore.http.upload) initialStateStore.http.upload = false

  if (initialStateStore.mapWS !== undefined &&
    initialStateStore.mapWS.maps.length > 0) initialStateStore.mapWS.maps = []

  if (initialStateStore.authWS !== undefined &&
    initialStateStore.authWS.user !== undefined &&
    initialStateStore.authWS.user.authtoken !== undefined) {
    Constants.UrlsConstants.header.authtoken = initialStateStore.authWS.user.authtoken
    Constants.UrlsConstants.header.refreshtoken = initialStateStore.authWS.user.refreshtoken
    Constants.UrlsConstants.authTokenParam = '?authtoken=' + initialStateStore.authWS.user.authtoken
  }

  if (initialStateStore.contentWS !== undefined &&
    initialStateStore.contentWS.AddressBooks !== undefined &&
    initialStateStore.contentWS.AddressBooks.length > 0) initialStateStore.contentWS.AddressBooks = []

  return initialStateStore
}
